import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

const MARKER_SIZE = "16px";

export const useAiDraftedItemNameStyles = makeStyles({
  root: {
    display: "inline-flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
    minWidth: 0,
  },
  marker: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: MARKER_SIZE,
    height: MARKER_SIZE,
    flexShrink: 0,
    fontSize: MARKER_SIZE,
  },
  draftedMarker: {
    color: projectIqTokens.amber,
  },
  reviewedMarker: {
    color: designTokens.semantic.successDark,
  },
});
